var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useQuery } from '@tanstack/react-query';
import { useLucidSdk } from '#context';
import { toMemberViewModels } from '#models';
import { WorkspaceMembersKeyFactory } from '../../query-key-factories';
import { canFetchWorkspaceData } from '../../services';
import { useCurrentMemberByWorkspaceId } from './useCurrentMemberByWorkspaceId';
import { useGetWorkspaceLoginStatus } from './useGetWorkspaceLoginStatus';
export const useMembersByWorkspaceId = ({ withGroups = false, workspaceId, }, { enabled = true } = {}) => {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const { query: { data }, } = useCurrentMemberByWorkspaceId(workspaceId);
    const { query: { data: workspaceLoginStatus }, } = useGetWorkspaceLoginStatus(workspaceId);
    const isQueryEnabled = Boolean(data?.privileges?.membersRead) &&
        canFetchWorkspaceData(workspaceLoginStatus) &&
        enabled;
    const query = useQuery({
        queryKey: WorkspaceMembersKeyFactory.byWorkspace(workspaceId, withGroups),
        queryFn: () => lucidSdk
            .workspaceClient(workspaceId)
            .memberManagement()
            .listMembers(withGroups),
        enabled: isQueryEnabled,
        networkMode: 'always',
        select: toMemberViewModels,
    });
    return { query };
};
_react_refresh_temp_1(useMembersByWorkspaceId, "tSAErbeuob4/XfdcEqZwDWAyuKA=", false, () => [useLucidSdk, useCurrentMemberByWorkspaceId, useGetWorkspaceLoginStatus, useQuery]);
